import React, { useMemo } from 'react';
import { FeatureFlagProvider } from '@bench/ff-client';
import { useTaskManagerContext } from './TaskManagerContext';
import { SplitFeatureFlags } from 'bk-web-app/features';

export const TaskManagerFeatureFlagProvider = ({ children }: React.PropsWithChildren) => {
  const { loggedInPerson } = useTaskManagerContext();

  const config = useMemo(
    () => ({
      core: {
        authorizationKey: window.BENCH ? window.BENCH.vendor.split.authorizationKey : '',
        // In task manager, we target by bookkeeperId but Split requires a clientId as the key.
        key: '-1',
      },
    }),
    [],
  );

  const clientAttributes = useMemo(
    () => ({ bookkeeperId: loggedInPerson.id }),
    [loggedInPerson.id],
  );

  const features = useMemo(() => Object.values(SplitFeatureFlags), []);

  return (
    <FeatureFlagProvider
      config={config}
      // @ts-expect-error - we only pass bookkeeperId here since it's the only valid attribute.
      clientAttributes={clientAttributes}
      features={features}
    >
      {children}
    </FeatureFlagProvider>
  );
};
